﻿<template>
    <header class="header">
        <header_menu></header_menu>
    </header>
    
    <main class="p-4">
        <div>
            <a @click="Go_Home()" class="cursor-pointer">
                <svg class="inline -mt-1 mr-1 w-3 svg-inline--fa fa-home fa-w-18 fa-2x" aria-hidden="true" focusable="false" data-prefix="far" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M341.8 72.6C329.5 61.2 310.5 61.2 298.3 72.6L74.3 280.6C64.7 289.6 61.5 303.5 66.3 315.7C71.1 327.9 82.8 336 96 336L112 336L112 512C112 547.3 140.7 576 176 576L464 576C499.3 576 528 547.3 528 512L528 336L544 336C557.2 336 569 327.9 573.8 315.7C578.6 303.5 575.4 289.5 565.8 280.6L341.8 72.6zM304 384L336 384C362.5 384 384 405.5 384 432L384 528L256 528L256 432C256 405.5 277.5 384 304 384z"/></svg>
                HOME
            </a>
            &nbsp;/&nbsp;  
            <svg class="inline -mt-1 mr-1 w-3 svg-inline--fa fa-user fa-w-14 fa-2x" aria-hidden="true" focusable="false" data-prefix="far" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"></path></svg>
            MY PROFILE
        </div>

        <h1>My Profile</h1>
        <div class="grid grid-cols-1 md:grid-cols-2">
            <div class="bg-grey-lightest col-span-1 md:col-span-2 p-2 my-2 border-2 rounded border-grey-default">
                <consultant_information :selected_contact="Get_Contact()"></consultant_information>
            </div>
            <div class="bg-grey-lightest border-2 p-2 my-2 rounded border-grey-default md:mr-2">
                <account_information></account_information>
            </div>
            <div class="bg-grey-lightest border-2 p-2 my-2 rounded border-grey-default">
                <change_account_password></change_account_password>
            </div>
        </div>
    </main>
    

</template>

<script lang="ts" src="./my_profile.ts"></script>